const state = {
  settings: {}
}

const getters = {
  baseUrl: state => state.settings || 'NotSet'
}

const mutations = {
  setSettings (state, settings) {
    state.settings = { settings }
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/settings.js